// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"f276ea03","391":"5467fa9b","950":"cd8e05d4"}[chunkId] + ".chunk.js";
};